import axios from 'axios';

// import {createStore} from 'vuex';

const state = {};
const getters = {};
const mutations = {};
const actions = {
    device: async ({ commit }, getData) => {
        return await axios
            .post('/devices', getData)
            .then((resp) => {
                return resp;
            })
            .catch((error) => {
                return error.response;
            });
    },
    getDevice: async ({ commit, dispatch }, getData) => {
        return await axios
            .get(`/devices?query=${getData.query}&direction=${getData.direction}&sort_by=${getData.orderBy}&page=${getData.page}&per_page=${getData.limit}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    updateDevice: async ({ commit, dispatch }, getData) => {
        return await axios
            .put(`/devices/${getData.id}`, getData)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                return error.response;
            });
    },
    editDevice: async ({ commit }, getData) => {
        return await axios
            .get(`/devices/${getData.id}`)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                return error.response;
            });
    },
    deleteDevice: async ({ commit }, id) => {
        return await axios
            .delete(`/devices/${id}`)
            .then((resp) => {
                return resp;
            })
            .catch((error) => {
                return error.response;
            });
    },
    downloadLicence: async ({ commit }, id) => {
        return await axios
            .get(`/licence/${id}`)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'voip.lic');
                document.body.appendChild(link);
                link.click();
                link.remove();
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
